<template>
  <div>
    <portal target-el="#filter">
      <primary-filter
        :noSearchFilter="true" />
    </portal>
  </div>
</template>
<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';

export default {
  components: { PrimaryFilter },
  created() {
    const token = localStorage.getItem('tsm-user-token');
    const baseUrl = this.$route.query.serviceUrl;
    const url = `https://${baseUrl}?token=${token}`;
    window.open(url, '_self');
  },
};
</script>
